const saveTracecode = () => {
  setTracecodeToCookie(
    selectTracecodeToSave(getTracecodeFromCookie(), getTracecodeFromUrl())
  )
}
const saveContactedAdvertisements = () => {
  setContactedAdvertisementsFromCookie(
    selectContactedAdvertisementsToSave(getContactedAdvertisementsFromCookie(), getTracecodeFromUrl())
  )
}

/* tracecodeドメイン */
const selectTracecodeToSave = (saved_tracecode, new_tracecode) => {
  const overwrite_prohibition_lists = ["moshi", "hachi", "afb", "wlz"]
  return overwrite_prohibition_lists.includes(saved_tracecode) ? saved_tracecode : new_tracecode
}
const selectContactedAdvertisementsToSave = (saved_contacted_advertisements, new_tracecode) => {
  return [
    ...saved_contacted_advertisements,
    {
      [tracecode_key]: new_tracecode,
      [contact_date_key]: contact_date()
    }
  ].reverse().slice(0, contacted_advertisement_size).reverse()
}
const contact_date = () => {
  const now = new Date()
  const year = now.getFullYear().toString().padStart(4, '0')
  const month = (now.getMonth() + 1).toString().padStart(2, '0')
  const date = now.getDate().toString().padStart(2, '0')
  return `${year}${month}${date}`
}

/* 初期設定 */
const tracecode_key = "tracecode"
const contact_date_key = "contact_date"
const domain = ".on-the-slope.com"
const contacted_advertisement_key = "contacted_advertisements"
const contacted_advertisement_size = 10
const cookie_expires = () => {
  const now = new Date()
  now.setTime(now.getTime() + 365 * 60 * 60 * 24 * 1000)
  return now.toUTCString()
}

/* urlからtracecodeを取得 */
const getTracecodeFromUrl = () => (getQueris().find((vals) => vals[0] === tracecode_key) || [])[1]

/* cookieを直接触るメソッド */
const getTracecodeFromCookie = () => getItem(document.cookie)[tracecode_key]
const setTracecodeToCookie = (tracecode) => {
  if (!tracecode) {
    return
  }
  setCookie(tracecode_key, encodeURIComponent(tracecode))
}
const getContactedAdvertisementsFromCookie = () => {
  const from_cookie = getItem(document.cookie)[contacted_advertisement_key]
  return from_cookie ? JSON.parse(from_cookie) : []
}
const setContactedAdvertisementsFromCookie = (contacted_advertisements) => {
  setCookie(contacted_advertisement_key, encodeStringAndConvertToJson(contacted_advertisements))
}
const setCookie = (key, val) => {
  document.cookie = `${key}=${val}; expires=${cookie_expires()}; path=/; domain=${domain};`
}

/* cookieに関連する基本的な処理群 */
const getItem = (semicolon_separated_string) => {
  const semicolon_separated_array = semicolon_separated_string.split('; ')
  const result = Object.create(null)
  for (const item of semicolon_separated_array) {
    const [key, value] = item.split('=')
    if (value !== undefined) {
      result[key] = decodeURIComponent(value)
    }    
  }
  return result
}
const encodeStringAndConvertToJson = (value) => {
  return encodeURIComponent(JSON.stringify(value))
}

/* urlに関連する処理 */
const getQueris = () => {
  return window.location.search.slice(1).split("&").map((query) => query.split("="))
}

export {saveTracecode, saveContactedAdvertisements}